import { render, staticRenderFns } from "./PromotionsForm.vue?vue&type=template&id=5f443982&scoped=true"
import script from "./PromotionsForm.vue?vue&type=script&lang=js"
export * from "./PromotionsForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionsForm.vue?vue&type=style&index=0&id=5f443982&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f443982",
  null
  
)

export default component.exports